import React, { useEffect, useState } from 'react'
import { ButtonBack, ButtonOutlined, ButtonPrimary } from '../../../../../components/button/ButtonCustoms';
import { Grid, Typography } from '@mui/material';
import { MeetingRoomApi } from '../../../../../api/meeting-room/meeting-room.api';
import { NavigateFunction, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { routeName } from '../../../../../routes/routeName';
import { alertActive, swalError, swalSuccess } from '../../../../../components/alert/swal';
import OptionsButtonCustom from '../../../../../components/button/OptionsButtonCustom';
import ModalCustom from '../../../../../components/modal/ModalCustom';
import InputTextField from '../../../../../components/input/inputTextField';
import { useTranslation } from 'react-i18next';

export default function AgendaInformation() {
    const navigate: NavigateFunction = useNavigate();
    const [searchParams] = useSearchParams();
    const mode = searchParams.get("mode");
    const [listAgendas, setListAgendas] = useState<any[]>([]);
    const [subListAgendas, setSubListAgendas] = useState<any[]>([]);
    const [idAgenda, setIdAgenda] = useState<any>();
    const { id } = useParams();
    const [open, setOpen] = useState<boolean>(false)
    const [form, setForm] = useState<any>()
    const { t } = useTranslation();

    const [meetingType, setMeetingType] = useState<any[]>([])
    const getListAgendas = async () => {
        const res = await MeetingRoomApi.listAgendas(id);
        const data = res.data
        console.log(data);
        setListAgendas(data.filter((x: any) => x?.status !== 'delete'))
    }
    const getListSubAgendas = async () => {
        const res = await MeetingRoomApi.getAgendas(id, idAgenda);
        const data = res.data
        console.log(data);
        setSubListAgendas(data?.sub_agenda.filter((x: any) => x?.status !== 'delete'))
    }

    useEffect(() => {
        if (id) {
            getListAgendas()
        }
    }, [])
    useEffect(() => {
        if (idAgenda) {
            getListSubAgendas()
        }

    }, [idAgenda])

    const handleSubmit = async () => {
        const body = {
            meeting_resolution: form?.meeting_resolution,
            id_meeting_room_file: undefined
        }
        await MeetingRoomApi.postResolution(body, id).then((res: any) => {
            console.log(res);
            if (res.status < 300) {
                swalSuccess(t('MEETING.ADD_MEETING_RESOLUTION_SUCCESS'))

                // handleClose()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
        })
    }
    const handleDelete = async (id_agenda: any) => {
        await MeetingRoomApi.deleteAgenda(id, id_agenda).then((res: any) => {
            if (res.status < 300) {
                swalSuccess(t('MEETING.MEETING_COORDINATOR_DELETE_SUCCESS'))
                getListAgendas()
                getListSubAgendas()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
        })

    }
    return (
        <div className='w-full grid grid-cols-12 gap-4 mt-[40px]'>

            <div className='col-span-12 md:col-span-12 lg:col-span-6 border-2 rounded-lg border-[#4A4A4A] relative h-[480px]'>
                <div className="flex items-center justify-between gap-4 bg-[#4A4A4A] p-[20px] ">
                    <Typography sx={{ fontSize: '24px', fontWeight: '500', color: "#ffff" }}>{t("วาระหลัก")}</Typography>
                    {!mode && <ButtonOutlined
                        onClick={() => {
                            navigate(routeName.cms.AddAgenda.replace(':id', `${id}`))
                        }}
                        buttonName={t("เพิ่ม")}
                        btnProps={{
                            width: "150px",
                        }}
                    />}
                </div>
                <div style={{ display: "flex", flexDirection: 'column', gap: '10px', padding: '10px',overflow:'auto',height:'400px' }}>
                    {listAgendas?.map((item: any) => {
                        return (
                            <div style={{
                                border: '1px solid  #F2F4F7',
                                padding: '16px',
                                borderRadius: '8px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                boxShadow: '0px 0px 7px -2px #1018281A'
                            }} onClick={() => setIdAgenda(item?.id_meeting_agenda)}>
                                {item?.meeting_agenda_name}
                                <OptionsButtonCustom
                                    enableView
                                    enableEdit={!mode}
                                    enableDelete={!mode}
                                    // enableResolution
                                    onViewClick={() => {
                                        navigate(routeName.cms.AddAgenda.replace(':id', `${id}`) + `?id=${item?.id_meeting_agenda}&mode=VIEW`)
                                    }}
                                    onCopy={() => {

                                    }}
                                    // onResolutionClick={() => {
                                    //     setOpen(true)
                                    //     setForm(item)
                                    // }}
                                    onEditClick={() => {
                                        navigate(routeName.cms.AddAgenda.replace(':id', `${id}`) + `?id=${item?.id_meeting_agenda}`)
                                    }}
                                    onDeleteClick={() => {
                                        alertActive(t('ยืนยันที่จะลบ หรือไม่?'), '', t('ยืนยัน'), t('ยกเลิก'), () => {
                                            handleDelete(item?.id_meeting_agenda)
                                        })
                                    }} />
                            </div>
                        )
                    })}
                </div>

            </div>

            <div className='col-span-12 md:col-span-12 lg:col-span-6 border-2 rounded-lg border-[#737373] relative h-[480px]'>
                <div className="flex items-center justify-between gap-4 bg-[#737373] p-[20px] ">
                    <Typography sx={{ fontSize: '24px', fontWeight: '500', color: "#ffff" }}>{t("วาระย่อย")}</Typography>

                    {!mode && idAgenda && <ButtonOutlined
                        onClick={() => {
                            navigate(routeName.cms.AddSubAgenda.replace(':id', `${id}`).replace(':idAgenda', `${idAgenda}`))
                        }}
                        buttonName={t("เพิ่ม")}
                        mode='add_request'
                        btnProps={{
                            width: "150px",
                        }}
                    />}
                </div>
                <div style={{ display: "flex", flexDirection: 'column', gap: '10px', padding: '10px', overflow:'auto',height:'400px' }}>
                    {subListAgendas?.map((item: any) => {
                        return (
                            <div style={{
                                border: '1px solid  #F2F4F7',
                                padding: '16px',
                                borderRadius: '8px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                boxShadow: '0px 0px 7px -2px #1018281A'

                            }}>
                                {item?.meeting_agenda_name}
                                <OptionsButtonCustom
                                    enableView
                                    enableEdit={!mode}
                                    enableDelete={!mode}
                                    // enableResolution
                                    onViewClick={() => {
                                        navigate(routeName.cms.AddSubAgenda.replace(':id', `${id}`).replace(':idAgenda', `${item?.id_meeting_agenda_ref}`) + `?id=${item?.id_meeting_agenda}&mode=VIEW`)
                                    }}

                                    onEditClick={() => {
                                        // navigate(
                                        //     routeName.cms.MeetingCaledarDetail.replace(':id', id_meeting_room)
                                        // );
                                        navigate(routeName.cms.AddSubAgenda.replace(':id', `${id}`).replace(':idAgenda', `${item?.id_meeting_agenda_ref}`) + `?id=${item?.id_meeting_agenda}`)
                                    }}
                                    // onResolutionClick={() => {
                                    //     setOpen(true)
                                    //     setForm(item)
                                    // }}
                                    onDeleteClick={() => {
                                        alertActive(t('ยืนยันที่จะลบ หรือไม่?'), '', t('ยืนยัน'), t('ยกเลิก'), () => {
                                            // handleDelete(id_course_of_study)
                                            handleDelete(item?.id_meeting_agenda)
                                        })
                                    }} />
                            </div>
                        )
                    })}
                </div>
            </div>
            <ModalCustom title={t('MEETING.MEETING_RESOLUTIONS')} subTitle={form?.meeting_agenda_name} open={open} component={
                <div>
                    <Grid container spacing={2}>

                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={12}
                            sx={{
                                alignSelf: "end",
                            }}
                        >

                            <InputTextField
                                heading={t('MEETING.RESOLUTION_DETAILS')}
                                placeholder={''}
                                value={form?.meeting_resolution || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    setForm({ ...form, meeting_resolution: e.target.value });
                                }
                                }
                                helperText={
                                    ""
                                }
                                inputHeight={'auto'}
                                minRow={6}
                                multiline
                            />
                        </Grid>


                    </Grid>
                    <div className='flex justify-center gap-4 mt-4'>
                        <ButtonBack
                            onClick={() => {
                                setOpen(false)
                                setForm(null)

                            }}
                            buttonName={t('ยกเลิก')}
                        />
                        <ButtonPrimary
                            onClick={() => {
                                setOpen(false)
                                handleSubmit()
                            }}
                            mode='add'
                            buttonName={t('ยืนยัน')}
                        />
                    </div>
                </div>
            } />
        </div>
    )
}
